import script from "./reservationOtherInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./reservationOtherInfo.vue?vue&type=script&setup=true&lang=js"

import "./reservationOtherInfo.vue?vue&type=style&index=0&id=b7fd6e96&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7fd6e96"]])

export default __exports__